import React, { useState } from "react";
import { Transforms } from "slate";
import { ReactEditor, useSlateStatic } from "slate-react";
import {
  RenderElementProps,
  ImageElement as ImageElementType,
  ImageSize,
} from "components/ManualBuilder/types";
import { ElementRenderer } from "../elementMap";

const getSizeClass = (size?: ImageSize): string => {
  switch (size) {
    case "small":
      return "w-1/4";
    case "medium":
      return "w-1/2";
    case "large":
    default:
      return "w-full";
  }
};

export const imageElement: ElementRenderer =
  () =>
  ({ attributes, children, element }: RenderElementProps) => {
    const imageElement = element as ImageElementType;
    const editor = useSlateStatic();
    const [showControls, setShowControls] = useState(false);

    const currentSize = imageElement.size || "large";

    const handleSizeChange = (size: ImageSize) => {
      const path = ReactEditor.findPath(editor, element);
      Transforms.setNodes(editor, { size }, { at: path });
    };

    return (
      <div {...attributes} contentEditable={false} className="my-4">
        <div
          contentEditable={false}
          className="relative inline-block group"
          onMouseEnter={() => setShowControls(true)}
          onMouseLeave={() => setShowControls(false)}
        >
          <img
            src={imageElement.url}
            alt=""
            className={`${getSizeClass(
              currentSize
            )} h-auto rounded transition-all duration-200`}
          />

          {showControls && (
            <div className="absolute top-2 left-2 bg-white border-2 border-gray-300 rounded-lg shadow-xl p-2">
              <div className="text-xs text-gray-800 mb-1 font-semibold">
                Image Size:
              </div>
              <div className="flex gap-1">
                <button
                  type="button"
                  onClick={() => handleSizeChange("small")}
                  className={`px-3 py-1 text-xs font-medium rounded transition-colors border ${
                    currentSize === "small"
                      ? "bg-cyan-600 text-white border-cyan-600"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:border-gray-400"
                  }`}
                  title="Small (25% width)"
                >
                  S
                </button>
                <button
                  type="button"
                  onClick={() => handleSizeChange("medium")}
                  className={`px-3 py-1 text-xs font-medium rounded transition-colors border ${
                    currentSize === "medium"
                      ? "bg-cyan-600 text-white border-cyan-600"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:border-gray-400"
                  }`}
                  title="Medium (50% width)"
                >
                  M
                </button>
                <button
                  type="button"
                  onClick={() => handleSizeChange("large")}
                  className={`px-3 py-1 text-xs font-medium rounded transition-colors border ${
                    currentSize === "large"
                      ? "bg-cyan-600 text-white border-cyan-600"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:border-gray-400"
                  }`}
                  title="Large (100% width)"
                >
                  L
                </button>
              </div>
            </div>
          )}
        </div>
        {children}
      </div>
    );
  };
